module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qcode"
  }, [_c('header', [_c('div', {
    staticClass: "headerTitle"
  }, [_c('h1', [_vm._v("请选择模板")]), _vm._v(" "), _c('el-steps', {
    attrs: {
      "active": 0,
      "finish-status": "success",
      "align-center": ""
    }
  }, [_c('el-step', {
    attrs: {
      "title": "选模板",
      "icon": "el-icon-picture"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "填信息",
      "icon": "el-icon-edit"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "上传",
      "icon": "el-icon-upload"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-radio-group', {
    staticClass: "el-radio-myStyle",
    model: {
      value: (_vm.CardRadio),
      callback: function($$v) {
        _vm.CardRadio = $$v
      },
      expression: "CardRadio"
    }
  }, [_c('ul', [_vm._l((_vm.cardTypeList), function(cardType) {
    return [_c('QrcodeTypeCard', {
      key: 'card' + cardType,
      attrs: {
        "Card_type": cardType,
        "Card_ImgPath": (_vm.OSS_URL + "/" + cardType + ".jpg/" + _vm.commonStyle)
      }
    })]
  }), _vm._v(" "), _c('el-badge', {
    staticClass: "item",
    attrs: {
      "value": "Beta"
    }
  }, [_c('p', [_vm._v("以下是彩色版测试")])]), _vm._v(" "), _c('QrcodeTypeCard', {
    attrs: {
      "Card_type": 'color-2',
      "Card_ImgPath": (_vm.OSS_URL + "/color-2.jpg/" + _vm.commonStyle)
    }
  })], 2)]), _vm._v(" "), _c('footer', [_c('div', {
    staticClass: "footer"
  }, [_c('router-link', {
    attrs: {
      "to": "/WriteInfo"
    }
  }, [_c('Button', {
    staticClass: "next_btn",
    class: {
      'next_btn_disabled': _vm.CardRadio == ''
    },
    attrs: {
      "disabled": _vm.CardRadio == ''
    }
  }, [_vm._v("\n                下一步\n            ")])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-360ab022","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SelectQcodeType.vue
// module id = 204
// module chunks = 1